import type { ConsentState } from "@/lib/posthog";

type GtagConsentValue = "granted" | "denied";
type GtagCommand = "config" | "consent" | "js" | "set";
type GtagConsentCommand = "default" | "update";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (command: GtagCommand, target: string | Date, config?: Record<string, unknown>) => void;
  }
}

let googleConsentDefaultSet = false;

function getConsentValue(enabled: boolean): GtagConsentValue {
  return enabled ? "granted" : "denied";
}

function initializeDataLayer() {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag(...args) {
    window.dataLayer?.push(args);
  };
}

export function updateGoogleConsent(state: ConsentState) {
  if (typeof window === "undefined") return;

  initializeDataLayer();
  const consentCommand: GtagConsentCommand = googleConsentDefaultSet ? "update" : "default";
  window.gtag?.("consent", consentCommand, {
    analytics_storage: getConsentValue(state.analytics),
    ad_storage: getConsentValue(state.marketing),
    ad_user_data: getConsentValue(state.marketing),
    ad_personalization: getConsentValue(state.marketing),
  });
  googleConsentDefaultSet = true;
}
